import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import Home from "./App/Home";
import LandingPage from "./App/Landing/LandingPage";
import NotFound from "./Components/NotFound";
import Login from "./App/Account/Login";
import ForgotPassword from "./App/Account/ForgotPassword";
import Footer from "./Components/Footer";
import ProductOrientation from "./App/ProductOrientation";
import SelectProductSize from "./App/SelectProductSize";
import ConfirmRegistration from "./App/Account/confirmRegistration";
import AuthPage from "./App/Account/authPage";
import { AuthProvider } from "./Providers/auth";
import Canvas from "./App/Canvas/Canvas";
import RequireAuth from "./helpers/requireAuth";
import MyAccounts from "./App/Account/MyAccounts";
import PhotoBook from "./App/PhotoBook/PhotoBook";
import MyOrders from "./App/Account/Orders";
import YourCart from "./App/Account/YourCart";
import ShippingDetails from "./App/Account/ShippingDetails";
import PaymentDetails from "./App/Account/PaymentDetails";
import ResetPassword from "./App/Account/ResetPassword";
import PayCard from "./App/Account/PayCard";
import SetProjectName from "./App/PhotoBook/SetProjectName";
import PhotoesPerPage from "./App/PhotoBook/PhotosPerPage";
import ChoosePageCount from "./App/PhotoBook/ChoosePageCount";
import PaymentSuccessLoad from "./App/Account/PaymentSuccessLoad";
import PhotobookEditor from "./App/PhotoBook/PhotobookEditor";
import CanvasProjectName from "./App/Canvas/CanvasProjectName";
import BannerEditor from "./App/Banner/BannerEditor";

function App() {
  const footerLinks = [
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms of Service", href: "/terms" },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        <BrowserRouter>
          <AuthProvider>
            <RoutesWrapper footerLinks={footerLinks} />
          </AuthProvider>
          <ToastContainer />
        </BrowserRouter>
      </main>
    </div>
  );
}

function RoutesWrapper({ footerLinks }: { footerLinks: { name: string; href: string }[] }) {
  const location = useLocation(); // Now inside the Router context

  // Define routes where you don't want the footer to appear
  const hideFooterRoutes = ["/canvas", "/", "/login", "/registration", "/forgotpassword", "/myaccounts", "/orders", "/yourcart", "/shippingdetails", "/paymentdetails"].map(
    (path) => (process.env.REACT_APP_PublicPath + path).toLowerCase()
  );
  const isBannerEditor = location.pathname.toLowerCase().startsWith((process.env.REACT_APP_PublicPath + "/banner-editor/").toLowerCase());
  const shouldShowFooter = !hideFooterRoutes.includes(location.pathname.toLowerCase()) && !isBannerEditor;

  return (
    <>
      <Routes>
        <Route
          path={process.env.REACT_APP_PublicPath + "/"}
          element={<LandingPage />}
        />
        <Route
          path={process.env.REACT_APP_PublicPath + "/login"}
          element={<AuthPage />}
        />
        <Route path={process.env.REACT_APP_PublicPath + "/home"} element={<Home />} />
        <Route
          path={process.env.REACT_APP_PublicPath + "/registration"}
          element={<AuthPage />}
        />
        <Route
          path={process.env.REACT_APP_PublicPath + "/forgotpassword"}
          element={<ForgotPassword />}
        />
        <Route path={process.env.REACT_APP_PublicPath + "/canvas"}
          element={
            <RequireAuth>
              <Canvas />
            </RequireAuth>
          }
        />
        <Route
          path={process.env.REACT_APP_PublicPath + "/orientation"}
          element={<ProductOrientation />}
        />
        <Route
          path={process.env.REACT_APP_PublicPath + "/productsize"}
          element={<SelectProductSize />}
        />
        <Route path={process.env.REACT_APP_PublicPath + "/confirm-registration"}
          element={<ConfirmRegistration />}
        />
        <Route path={process.env.REACT_APP_PublicPath + "/myaccounts"} element={<MyAccounts />} />
        <Route path={process.env.REACT_APP_PublicPath + "/photobook"} element={<PhotoBook />} />
        <Route path={process.env.REACT_APP_PublicPath + "/Orders"} element={<MyOrders />} />
        <Route path={process.env.REACT_APP_PublicPath + "/yourcart"} 
          element={
            <RequireAuth>
            <YourCart />
            </RequireAuth>         
          } />
        <Route path={process.env.REACT_APP_PublicPath + "/shippingdetails"} 
          element={
            <RequireAuth>
              <ShippingDetails />
            </RequireAuth>          
          } />
        <Route path={process.env.REACT_APP_PublicPath + "/paymentdetails"} 
          element={
            <RequireAuth>
              <PaymentDetails />
            </RequireAuth>          
          } />
        <Route path={process.env.REACT_APP_PublicPath + "/reset-password"} element={<ResetPassword />} />
        <Route path={process.env.REACT_APP_PublicPath + "/paycard"} 
          element={
              <RequireAuth>
                <PayCard />
              </RequireAuth>          
          } />
        <Route path={process.env.REACT_APP_PublicPath + "/setproductname"} element={<SetProjectName />} />
        <Route path={process.env.REACT_APP_PublicPath + "/productorientation"} element={<PhotoesPerPage />} />
        <Route path={process.env.REACT_APP_PublicPath + "/choosepagecount"} element={<ChoosePageCount />} />
        <Route path={process.env.REACT_APP_PublicPath + "/paymentsuccessmessage"}
          element={<PaymentSuccessLoad />}
        />
        <Route path={process.env.REACT_APP_PublicPath + "/photobookeditor"}
          element={
            <RequireAuth>
              <PhotobookEditor />
            </RequireAuth>
          }
        />
         <Route path={process.env.REACT_APP_PublicPath + "/canvasname"}
          element={
            <RequireAuth>
              <CanvasProjectName />
            </RequireAuth>
          }
        />
        <Route path={process.env.REACT_APP_PublicPath + "/banner-editor/:bannerId"}
          element={
            <RequireAuth>
              <BannerEditor />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* Conditionally render Footer */}
      {shouldShowFooter && <Footer links={footerLinks} copyright="© 2024 My Website" />}
    </>
  );
}

export default App;
